module.exports = "/images/vendor/flag-icon-css/flags/4x3/se.svg?fd663a70a1a92a395078c36bc5d122ad";